// extracted by mini-css-extract-plugin
module.exports = {"outer":"_36QDv","contentWrapper":"_1yqmg","heading":"_1Chhv","subHeading":"_3GrdV","itemCard":"_3Q7M1","itemCardWrapper":"_3fGgd","star":"_2H5DH"};